(() => {
  const SELECTOR = 'video[data-product-card-video]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting) {
          if (!video.src) {
            video.src = video.dataset.src;
            video.addEventListener(
              'playing',
              () => video.parentElement.classList.add('is-playing'),
              { once: true }
            );
          }
          video.muted = true;
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        } else if (video.src) {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  const observe = (root) => {
    root.querySelectorAll(SELECTOR).forEach((video) => {
      if (video.dataset.observed) return;
      video.dataset.observed = 'true';
      observer.observe(video);
    });
  };

  const init = () => {
    observe(document);
    // Cards are re-rendered by filtering, sorting and infinite scroll
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) observe(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
